import React from 'react';
import classNames from 'classnames';

import css from './IconCreditCard.module.css';

/**
 * Credit card icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @returns {JSX.Element} SVG icon
 */
const IconCreditCard = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Credit card"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 7C4 6.44772 4.44772 6 5 6H19C19.5523 6 20 6.44772 20 7V8H4V7ZM4 18V11H20V18C20 18.5523 19.5523 19 19 19H5C4.44772 19 4 18.5523 4 18ZM5 4C3.34315 4 2 5.34315 2 7V9V10V18C2 19.6569 3.34315 21 5 21H19C20.6569 21 22 19.6569 22 18V10V9V7C22 5.34315 20.6569 4 19 4H5ZM14 14C13.4477 14 13 14.4477 13 15C13 15.5523 13.4477 16 14 16H18C18.5523 16 19 15.5523 19 15C19 14.4477 18.5523 14 18 14H14Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default IconCreditCard;

